import {
  type ProductAttributeSortInput,
  SortEnum,
} from "@zaprooecommerce/magento-types";
import { ProductSortOptionType } from "~/modules/settings/types";

export const MagentoSortOptions: Partial<
  Record<
    ProductSortOptionType,
    { field: keyof ProductAttributeSortInput | string; direction: SortEnum }
  >
> = {
  [ProductSortOptionType.relevance]: {
    field: "relevance",
    direction: SortEnum.Desc,
  },
  [ProductSortOptionType.position]: {
    field: "position",
    direction: SortEnum.Asc,
  },
  [ProductSortOptionType.price_asc]: {
    field: "price",
    direction: SortEnum.Asc,
  },
  [ProductSortOptionType.price_desc]: {
    field: "price",
    direction: SortEnum.Desc,
  },
  [ProductSortOptionType.name_asc]: {
    field: "name",
    direction: SortEnum.Asc,
  },
  [ProductSortOptionType.name_desc]: {
    field: "name",
    direction: SortEnum.Desc,
  },
  [ProductSortOptionType.discount_desc]: {
    field: "discount_percent",
    direction: SortEnum.Desc,
  },
};
